export const SET_LOADING = '@myorganization/SET_LOADING';
export const SAVE_DATA = '@myorganization/SAVE_DATA';
export const SET_FILTER = '@myorganization/SET_FILTER';
export const SET_ACTIVE_PAGE = '@myorganization/SET_ACTIVE_PAGE';
export const SAVE_BULK_USERS = '@myorganization/SAVE_BULK_USERS';



// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/constants.js